import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
import { LeadParagraph } from '../../components/LeadParagraph';
export const _frontmatter = {
  "pageTitle": "Checkbox Design Guidelines",
  "title": "Checkbox",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="checkbox" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  A checkbox is an input control that allows a user to select one or more
  options from a number of choices.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`Use checkboxes to:`}</p>
      <ul>
        <li parentName="ul">{`Select one or multiple items from a list`}</li>
        <li parentName="ul">{`Present a list containing sub-selections`}</li>
        <li parentName="ul">{`Turn an option/setting on or off`}</li>
      </ul>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.22007722007721%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAABW0lEQVQ4y51TyU7DMBDtL3NBXPg6UMUFUQ5VoUnbrF2yQQ5ZbMfzkK0kMq2rLiONZpSMn9/MG0/QGxHhXqP+sIoTE4xzjqXjIghD7HY7BEGALMuwXq91HoYhNpuN/hdFkc6llCPmCAiQwVCC8xZN06KqKnRdh6ZpdN62rc7VxXVd628GuVOGUhLePzLkRQsphT6oQO5vWUg8Pr/hZbrFfh9gsfiC67qa5VBncwtDc46EY32uEMzOUAgBx1kiTRMkSaIFGVo22NwGuFo5yPMcRVFoJdXwj9u9CnAorJsOXUe2wd/eMucSD09TvE63OBwieJ6P+XyOOI6tolwEVHHxXaL4YRCC6fmVZQnG2CWmdkC19VX1C8ZqvcAKSK2MAlau9vKMQP8AqV9M4pzTbPZJURST7/vkeR65rqtd5WmajrVDNFxjnrSsnpNS22b9uz0r0MjQdqPNzDqz3rQ/p++WtYVbxqIAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.7.0/static/f755ae759bf47970ae3d7201ae022e8f/0a47e/Checkbox-example.png",
              "srcSet": ["/version/4.7.0/static/f755ae759bf47970ae3d7201ae022e8f/a2ead/Checkbox-example.png 259w", "/version/4.7.0/static/f755ae759bf47970ae3d7201ae022e8f/6b9fd/Checkbox-example.png 518w", "/version/4.7.0/static/f755ae759bf47970ae3d7201ae022e8f/0a47e/Checkbox-example.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Checkboxes`}</p>{`
  `}</figcaption>
      </figure>
      <h2>{`Parent and Child Checkboxes`}</h2>
      <p>{`Checkboxes can have a parent-child relationship with other checkboxes.`}</p>
      <ul>
        <li parentName="ul">{`When the parent checkbox is checked, all child checkboxes are checked`}</li>
        <li parentName="ul">{`If a parent checkbox is unchecked, all child checkboxes are unchecked`}</li>
        <li parentName="ul">{`If some, but not all, child checkboxes are checked, the parent checkbox becomes an indeterminate checkbox`}</li>
      </ul>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "64.09266409266408%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA+UlEQVQ4y6VSwYrCMBD1Z/e4f+Vhb3vYiyAou/6CCqaNFpYmlpZiWkxJm+YtzW5A61oaHRiSMDMv783MBP+YMQZD5uIXpyswk3vJUjbgx7N9t20LrfUV0OWng4Ba/8YWnzFeXlc4nQQoDREEAQghYIzdgI5iKAqFfVRcFTu2/bYMAvaTOefIsgxSSpRliaqqHmHo2BiEYYhDFCGOY3tPksQP8JZl++f3VYyS3LHrbPoWYDb/RlnkYIxbhk3TjF+bPuD7xwHLLwalzlZ2N2WllB/gmAX3luxy1pstdoRYdpRSOxghhL9kl5OmKfI8R13XdmU69+7hM5J/AL9i/Ov0+/VTAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.7.0/static/750aed54bc4af80d31d75ae8fd933e85/0a47e/Checkbox-parent-child-example.png",
              "srcSet": ["/version/4.7.0/static/750aed54bc4af80d31d75ae8fd933e85/a2ead/Checkbox-parent-child-example.png 259w", "/version/4.7.0/static/750aed54bc4af80d31d75ae8fd933e85/6b9fd/Checkbox-parent-child-example.png 518w", "/version/4.7.0/static/750aed54bc4af80d31d75ae8fd933e85/0a47e/Checkbox-parent-child-example.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Parent-child relationship for checkboxes`}</p>{`
  `}</figcaption>
      </figure>
      <h2>{`States`}</h2>
      <p>{`Checkboxes can be selected, unselected, or indeterminate. Checkboxes have enabled, disabled, focused and pressed states.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.22007722007721%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAABcUlEQVQ4y6VUTUvDQBDt/z968eTBu0ipUPAseBFsFMGk2aZpUkqatGjafHTjZp/sJNvGGmvEgWU3w+ybN/Nm00NtUkpayna7HfI8xynTsfqz9sleGyBjE5imheVyCd/34bouHMeh3bZtcM6PQdsBlV9tH0WGgqfgvKDLirFeWZahLMtugHuGzgbM2UKIAlmWoygKAtPMOpcsRBV0cfmKs/MXJMkbbJtRqZZlwfM8CCG+JK/P3wF/yNxVmHaGZVkFDIYurvoO9XGxWCAIAqxWK6zXa0RRRGLFcXyaYRNweOuhf+MSoO/PSWkNGoYhla7AO5RcqVxVIP9fsg4wjCeMDIMYjcdjEoQx9ldRDkFpkmC73dBlNXdpmtLLUWPTBPp1bJRxUeJxusTDJMAmUQPOCUzPYRdAWZ9pT7iQg/tneX03kmw2l86ESdM0JWNMep4ny0q5ffxRw1ueHoBZFGMavnf9MTT9B4a6v2hmlu12zLBpn6XDkkNHg1cLAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.7.0/static/b6f5cf422806de32481cbb13323450aa/0a47e/Checkbox-states.png",
              "srcSet": ["/version/4.7.0/static/b6f5cf422806de32481cbb13323450aa/a2ead/Checkbox-states.png 259w", "/version/4.7.0/static/b6f5cf422806de32481cbb13323450aa/6b9fd/Checkbox-states.png 518w", "/version/4.7.0/static/b6f5cf422806de32481cbb13323450aa/0a47e/Checkbox-states.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Checkbox states`}</p>{`
  `}</figcaption>
      </figure>
      <h2>{`Colors`}</h2>
      <p>{`The default color used for checked checkboxes is primary-500 from the Magma palette, but sometimes a special scenario or specific UI can benefit from using one of the other colors from the palette. Colors like Info Blue (info-500), Success Green (success-500), or Danger Red (danger-500) can help add context when used responsibly and consistently.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "614px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.25096525096525%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsTAAALEwEAmpwYAAABf0lEQVQ4y41Ty07DMBDk//gALhy4cOYHOHHgL7jxHYgKxKGoEkitVKlNmlQlTSAl7zq2Yw9aN5Q0bWktjezE49Hu7O6J1hrHrAM8XXP0CR3SNMVsNoMQAowxFEVhkOe5gZTSvFJKo/PsIfgswDkzd8TLskzTW9I0gr7vYzAYIEkSI0xwXReO48CyLPOIlpQK1zev6PZ8LMI5HMfFdDoljqag1oIUb6X0kSnr/1Pe5w39bwIHPKx1VhEuCoF3L4VSCpxzs7dFV98K8WSAMosgZIWqWmNT8GEU4vSuhzTLMB6N8BWGOwWVFHi5Pcf87RHuh2+45PVwONTL5fJPkIkK85TtTLndMuw7QMXZL6kultR1Vpsetn1r3+3zeKsPS8kR5tH+6jYilYsQivOtimx42LG6OLu/QpzEsG0bnueZHqR+bEanhIBzeYHoqQM3CDCxbfT7fcRx3JqUMscwsEzFaFJKXqIsV2gK0s7GI8g4ApcSVAiaFqXU4T5se6eP7MMfSgryB+DqY4cAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.7.0/static/d03142a1b7cd4d845cb4fc5b50e0d26f/e9131/Checkbox-alternate-colors.png",
              "srcSet": ["/version/4.7.0/static/d03142a1b7cd4d845cb4fc5b50e0d26f/a2ead/Checkbox-alternate-colors.png 259w", "/version/4.7.0/static/d03142a1b7cd4d845cb4fc5b50e0d26f/6b9fd/Checkbox-alternate-colors.png 518w", "/version/4.7.0/static/d03142a1b7cd4d845cb4fc5b50e0d26f/e9131/Checkbox-alternate-colors.png 614w"],
              "sizes": "(max-width: 614px) 100vw, 614px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Alternate colors`}</p>{`
  `}</figcaption>
      </figure>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "600px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "77.22007722007721%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAABRElEQVQ4y52UzU6DQBSF+5w+iTtXrly5desjuDbpojHqwpSualKbCKQ40YGiwPzPMTOFhrbQptzk5vIz95tzwmVGqMNai6Fh62ZXR22YUgrz+TsWiwWiKAIhBMvlEnEc+xqGob92z5Mk8feup2EeADdVQEoOxjiklBBC+CyKAlVVgTHm073jnMMYcxz4FlB8/zDAagixAQ62rLXB5dUzHscRhPjDapV4e/XuvXmgcOej2E4FJ0V2KzQGN+M7vHxOIUqObJ0hTdMt9Ai4H3g7ucdrOPNAmlLkeX4+EO3Fbgz2GgdbNlphcn2B8OkB6W8F8pWAUjrcsqv5RwCeEUht/MhorYcD3ZCuC4aKO5CCUrr5E07Z3gHaejCtlNLOgqmNo8hSSi0hxNdmTbOuJz1ztL97WZZbVeceHFuFXQra0XbRle34B2yfmHRx4cVdAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.7.0/static/c677bea42653e27817bef8d4ceca558a/0a47e/Checkbox-incorrect-multi-color.png",
                  "srcSet": ["/version/4.7.0/static/c677bea42653e27817bef8d4ceca558a/a2ead/Checkbox-incorrect-multi-color.png 259w", "/version/4.7.0/static/c677bea42653e27817bef8d4ceca558a/6b9fd/Checkbox-incorrect-multi-color.png 518w", "/version/4.7.0/static/c677bea42653e27817bef8d4ceca558a/0a47e/Checkbox-incorrect-multi-color.png 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            Do not use multiple colors in the same UI. Pick one and stick with
            it.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "600px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "77.22007722007721%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAABDklEQVQ4y62T24qEMAyGff+HEXwJL7z0SkG8sIJUqAfwWLUZ/mAX5+DMjruBkKrJ1/xNdWg3YwxdNbMXIzpH2LIsFMcxJUlCQgiSUlKappTnOccsy3iN90VR8DNqLPMJiIiEeZ5pmibSWvMa3nUdDcNA4ziy4xtytm17D0QHKEaiBV6WDIjneRRFEfV9z7Igb9/91J86/DSUXwzsvEPf93kg6LBpGqqq6gf6BnwODIKAzxFAwNq2/R74OJh/ley6Lg+lrmseiFLqumTEsixZrr2P67r+7QxxZri4AAG6/wmfZN8BzX4xjdbahGFohBBGKWWklBxtjs07cWY6j7tbuV8Ohe46fNXB0Y4qXvnRbgrPmwC1s/cnAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/version/4.7.0/static/070f112f2dd768adc5626e415e8645f5/0a47e/Checkbox-incorrect-neutral.png",
                  "srcSet": ["/version/4.7.0/static/070f112f2dd768adc5626e415e8645f5/a2ead/Checkbox-incorrect-neutral.png 259w", "/version/4.7.0/static/070f112f2dd768adc5626e415e8645f5/6b9fd/Checkbox-incorrect-neutral.png 518w", "/version/4.7.0/static/070f112f2dd768adc5626e415e8645f5/0a47e/Checkbox-incorrect-neutral.png 600w"],
                  "sizes": "(max-width: 600px) 100vw, 600px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                  "className": "title title-incorrect"
                }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`
            If you are going to change the color, don't use a neutral color. This
            could be confused with a checkbox that is checked and disabled.
          `}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <h2>{`Inverse`}</h2>
      <p>{`Use the inverse version when using the checkboxes on a dark background.`}</p>
      <figure>{`
  `}<div parentName="figure" {...{
          "className": "image-container"
        }}>{`
    `}<span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "600px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "77.22007722007721%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+ElEQVQ4y5VUTW8SURTtDzEaKzDM0GGGz7ZWqoG2DtVOoEjxa+eiaxMJdIavoWlS+hEspcLKxKXRGOPanf/rHb13OpZSLHZxct97c99559x7MzOyVsMoJNVGJNlCdN5BYM6CpFp85kYLAdVCMGxzrhdlzRa812wxM4kwV+yj+GKA9ONDGBtdPMmdwCyc4mn+BPmtPsLxJudd3PsHofeiGmtCi58j0YSeaEFPuogttqHo9RF1UxT6lCrMQg8bmz3MRetsnRQRmafsvy2HInXcmn2H3tlPfPz0C4mlXbZIVgvPPyBrdjln3JGs1a4S0kcvwR/a4Yb4lB3clSqYDbq4J1f5jKI/ZI3em6yQanPbX4bd+Ib23g+2uLp+jLRxiFRmHw/S+3i40uFmLaT2rlfoEd7xl1Gxv6LhfOemUJfJasY4wvJKB4/WDpA13zP5SKevt0y2CGSdLLu2qze3TKDk0qshSq+HWM50sFk644bQbN64Ke5gW4guOIgvtvkyrWn2IkkHWqI1TjR9sEPRBoziAOulIWL3d7mOkXmHh5vWij6dUHiQVEuoSUe8eftZbJe/iGy+J3LPTkXx5UDkt/oia3aFotfEec3GwbW8ojCo1bC0doSUcYyAavM8epAm/hgu4ULh31fDtvDJVeGTK5NUXM719prt4o/C31KYOCEY/QD+AAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/version/4.7.0/static/4c83e2b8d786c19d1235a5ccdb9b87b6/0a47e/Checkbox-inverse.png",
              "srcSet": ["/version/4.7.0/static/4c83e2b8d786c19d1235a5ccdb9b87b6/a2ead/Checkbox-inverse.png 259w", "/version/4.7.0/static/4c83e2b8d786c19d1235a5ccdb9b87b6/6b9fd/Checkbox-inverse.png 518w", "/version/4.7.0/static/4c83e2b8d786c19d1235a5ccdb9b87b6/0a47e/Checkbox-inverse.png 600w"],
              "sizes": "(max-width: 600px) 100vw, 600px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>{`
  `}</div>{`
  `}<figcaption parentName="figure">{`
    `}<p parentName="figcaption">{`Inverse colors`}</p>{`
  `}</figcaption>
      </figure>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      